import React, { useState, useEffect } from 'react';
import { ModalWrapper, ButtonGroup } from 'components/molecules';
import { PopupProps } from 'react-popup-manager/dist/src';

import { Form, Button, Input, Space, Popconfirm, Row, Col, Select, message, Checkbox } from 'antd';
import { useB2cStudentDetail, useRefCode } from 'hooks';

import { CheckOutlined } from '@ant-design/icons'
import { CompanySelectBox, CrmSelectBox } from 'components/atoms'
import { CompanyMatchModal, FileViewerModal, StudentReinForceModal, StudentDeleteModal, CrmMatchModal } from 'components/molecules';
import { usePopupManager } from 'react-popup-manager';
import { DownloadOutlined, SearchOutlined } from '@ant-design/icons';
import { isFileViewer } from 'utils/file-utils';
import axios from 'axios';
import { endpoints } from 'services';
import { SERVER_URL } from 'commons/constants';
import { fetcher } from 'services';
import { MSG } from 'commons/constants';
import { IMaskInput } from "react-imask";
import { makeMaskPhoneNumber } from "utils/form-utils"

export interface StudentEditModalProps extends PopupProps {
    id: number;  
    group: string;
    lectureInfo: LectureInfoDto;
    refetch: ()=> void;
}

const StudentEditModal = ({ 
    isOpen, 
    onClose, 
    id, group, lectureInfo, refetch}: StudentEditModalProps): React.ReactElement => {
  /* ======================================================
   * states
   * ====================================================== */    
    const [memPrice, setMemPrice] = useState<number>(lectureInfo.lecture_price);
    const [salePrice, setSalePrice] = useState<number>(lectureInfo.lecture_price);
    const [routeOption, setRouteOption] = useState<any[]>([]);
    // const [routeOption, setRouteOption] = useState<any[]>(
    //     [
    //         {value:'HSG 이메일/뉴스레터', label: 'HSG 이메일/뉴스레터'},
    //         {value:'AI 검색', label: 'AI 검색'},
    //         {value:'네이버 검색', label: '네이버 검색'},
    //         {value:'구글 검색', label: '구글 검색'},
    //         {value:'블로그', label: '블로그'},
    //         {value:'세미나/설명회', label: '세미나/설명회'},
    //         {value:'칼럼/도서', label: '칼럼/도서'},
    //         {value:'지인 추천', label: '지인 추천'},
    //         {value:'HSG를 이전부터 알고 있었음', label: 'HSG를 이전부터 알고 있었음'},
    //         {value:'기타', label: '기타'},
    //     ]        
    // )

    /* ======================================================
  * hooks
  * ====================================================== */
  const {studentInfo, studentAttendList, studentInsert, studentUpdate, studentRestore, studentPenalty, studentAttend, restoreSuccess, insertSuccess, updateSuccess, penaltySuccess, attendSuccess } = useB2cStudentDetail(id, group);
  const { refCodeList: howknowList } = useRefCode({field:'how_know'});  

  const [companySrl, setCompanySrl] = useState<number>(0);
  const [eduCrmSrl, setEduCrmSrl] = useState<number>(0);
  const [eduCrmName, setEduCrmName] = useState<string>('');
  const [companyName, setCompanyName] = useState<string>('');  
  const [orgCompanyName, setOrgCompanyName] = useState<string>(''); 
  const [viewAttendList, setViewAttendList] = useState<boolean>(true);
  const [companyInfo, setCompanyInfo] = useState<CompanyCodeListDto>();  
   /* ======================================================
   * variables
   * ====================================================== */
  const [form] = Form.useForm();
  const { TextArea } = Input;
  const { open } = usePopupManager();  

   /* ======================================================
   * events
   * ====================================================== */
   const onSameStudent = () => {
    form.setFieldsValue({
        edu_name: form.getFieldValue('name_kor'),
        edu_phone: form.getFieldValue('phone'),
        edu_position: form.getFieldValue('position'),
        edu_email: form.getFieldValue('email'),
    });
}

    const onSameCrm = () => {
        form.setFieldsValue({
            acc_name: (eduCrmSrl > 0) ? eduCrmName : form.getFieldValue('edu_name'),
            acc_phone: form.getFieldValue('edu_phone'),
            acc_email: form.getFieldValue('edu_email'),
            acc_crm_srl: form.getFieldValue('edu_crm_srl'),
        });
    }

    const onReinforce = () => {
        open(StudentReinForceModal, {
            lectureInfo: lectureInfo,
            id: id,
            group: group,
            onClose: (isOk) => {
                if (isOk) {
                onClose?.(true);
                };
            },
        }); 
    }

    const onDelete = (putoff: boolean) => {
        
        if (!!studentInfo) {
            if (putoff) {
                if (studentInfo.bill_price > 0) {
                    alert("계산서가 발행되어 연기 할 수 없습니다.");
                } else {
                    open(StudentDeleteModal, {
                        lectureInfo: lectureInfo,
                        id: id,
                        group: group,
                        putoff: putoff,
                        onClose: (isOk) => {
                            if (isOk) {
                            onClose?.(true);
                            };
                        },
                    }); 
                }
            } else {
                if (studentInfo.bill_price > 0) {
                    alert("계산서가 발행되어 취소 할 수 없습니다.");
                } else {
                    open(StudentDeleteModal, {
                        lectureInfo: lectureInfo,
                        id: id,
                        group: group,
                        putoff: putoff,
                        onClose: (isOk) => {
                            if (isOk) {
                            onClose?.(true);
                            };
                        },
                    }); 
                }
            }   
        }
    }

    const onRestore = () => {
        studentRestore({
            id: id,
        }) 
    }

    const onPenalty = () => {
        const sData = {
            id: id,
            b2c_group_srl: lectureInfo.id,
            app_srl: studentInfo?studentInfo.app_srl:0,
            company: (!!companySrl) ? orgCompanyName? orgCompanyName: companyName: form.getFieldValue('company'),
            company_srl: companySrl,
            sale_price: salePrice,
            student_cnt: studentInfo?studentInfo.student_cnt:1,
            name_kor: form.getFieldValue('name_kor'),
            name_eng: form.getFieldValue('name_eng'),
            department: form.getFieldValue('department'),
            position: form.getFieldValue('position'),
            mem_price: Number(form.getFieldValue('mem_price').toString().replaceAll(',','')),
            phone: form.getFieldValue('phone'),
            email: form.getFieldValue('email'),
            ebill_yn: form.getFieldValue('ebill_yn'),
            ebill_etc: form.getFieldValue('ebill_etc'),
            route: form.getFieldValue('route'),
            memo: form.getFieldValue('memo'),
            memo2: form.getFieldValue('memo2'),
            memo3: form.getFieldValue('memo3'),
            duty: form.getFieldValue('duty'),
            sex: form.getFieldValue('sex'),
            age: form.getFieldValue('age'),
            edu_crm_srl: eduCrmSrl,
            edu_name: form.getFieldValue('edu_name')?form.getFieldValue('edu_name'):eduCrmName,
            edu_position: form.getFieldValue('edu_position'),
            edu_email: form.getFieldValue('edu_email'),
            edu_phone: form.getFieldValue('edu_phone'),
            edu_phone2: form.getFieldValue('edu_phone2'),
            acc_name: form.getFieldValue('acc_name'),
            acc_phone: form.getFieldValue('acc_phone'),
            acc_email: form.getFieldValue('acc_email'),
        }  
        studentPenalty(sData) 
    }    

    const onSubmit = (e) => {
        const sData = {
            id: id,
            b2c_group_srl: lectureInfo.id,
            app_srl: studentInfo?studentInfo.app_srl:0,
            company: (!!companySrl) ? orgCompanyName? orgCompanyName: companyName: e.company,
            company_srl: companySrl,
            sale_price: salePrice,
            student_cnt: studentInfo?studentInfo.student_cnt:1,
            name_kor: e.name_kor,
            name_eng: e.name_eng,
            department: e.department,
            position: e.position,
            mem_price: Number(form.getFieldValue('mem_price').toString().replaceAll(',','')),
            phone: e.phone,
            email: e.email,
            ebill_yn: e.ebill_yn,
            ebill_etc: e.ebill_etc,
            route: e.route,
            memo: e.memo,
            memo2: e.memo2,
            memo3: e.memo3,
            duty: e.duty,
            sex: e.sex,
            age: e.age,
            edu_crm_srl: eduCrmSrl,
            edu_name: e.edu_name?e.edu_name:eduCrmName,
            edu_position: e.edu_position,
            edu_email: e.edu_email,
            edu_phone: e.edu_phone,
            edu_phone2: e.edu_phone2,
            acc_name: e.acc_name,
            acc_phone: e.acc_phone,
            acc_email: e.acc_email,
        }  

        if (id > 0) {
            studentUpdate(sData);
        } else {
            studentInsert(sData);
        }

        if (!!studentInfo) {
 
        }
    };

    const onCloseClick = () => {
        onClose?.(studentInfo?.company_srl !== companySrl);
    }
    const onClickCompanyMatch = () => {
        if (studentInfo) {
            console.log(studentInfo);
            open(CompanyMatchModal, {
                company: studentInfo?.company,
                onClose: (isOk, company_srl, company_name) => {
                  if (isOk) {
                      setCompanySrl(company_srl);
                      setCompanyName(company_name);
      
                      fetcher.crm.postCrmAppCheck({
                          company_srl: company_srl,
                          edu_name: studentInfo.edu_name,
                          acc_name: studentInfo.acc_name
                      })
                      .then((res) => {
                          switch (res.code) {
                              case 200:
                                if (res.result && res.result.info) {
                                    setEduCrmSrl(res.result.info.edu_crm_srl);
                                }
                              break;
                              default:  
                                  message.error('검사중 오류 발생하였습니다.', 1);
                              break;
                          };
                      });  
                  };
                },
            }); 
        }
      }

      const onClickCrmMatch = (crm_srl: number, name: string, phone: string, email: string, position?: string, phone2?: string,) => {
        if (studentInfo) {
            open(CrmMatchModal, {
                company_srl: companySrl,
                company: companyName,
                crm_srl: crm_srl,
                name: name, 
                phone: phone, 
                phone2: phone2, 
                email: email, 
                position: position,
                onClose: (isOk, crm_srl, crm_name, org_name, org_phone, org_email, org_position, org_phone2) => {
                  if (isOk) {
                    setEduCrmSrl(crm_srl);
                    setEduCrmName(crm_name);
                    form.setFieldValue('edu_crm_srl', crm_srl);
                    form.setFieldValue('edu_name', org_name);
                    form.setFieldValue('edu_phone', org_phone);
                    form.setFieldValue('edu_email', org_email);
                    form.setFieldValue('edu_phone2', org_phone2);
                    form.setFieldValue('edu_position', org_position);
                  };
                },
            }); 
        }
      }

      const onOpenFileViewer = (fileId: number, fileName: string) => {
        open(FileViewerModal, {
          fileid: fileId,
          filename: fileName,
          onClose: (isOk) => {},
        });   
       }   

       const onDownload = (fileSeq:number, fileName: string): void => {
        axios({
          url: SERVER_URL + endpoints.file.download + '?file_id=' + fileSeq,
          method: 'get',
          responseType: 'blob',
        })
          .then((response) => {
            const url = window.URL.createObjectURL(new Blob([response.data]));
            const link = document.createElement('a');
            link.href = url;
            link.setAttribute('download', fileName);
            document.body.appendChild(link);
            link.click();
          })
          .catch(() => {
            message.error('파일 다운로드 중 에러가 발생했습니다.', 1);
          });
        };

    const onCompanyBusinessUpdate = () => {
        if (!!companySrl && !!studentInfo?.business_file_id) {
            fetcher.company.postCompanyBusinessFileIdUpdate({
                id: companySrl,
                business_number_file_id: studentInfo.business_file_id,
            })
            .then((res) => {
                switch (res.code) {
                    case 200:
                        message.info('정보가 등록 되었습니다.', 1);
                    break;
                    default:  
                        message.error('등록중 오류 발생하였습니다.', 1);
                    break;
                };
            });   
        }
    }
  /* ======================================================
   * effects
   * ====================================================== */
    useEffect(() => {
        if (!!studentInfo) {   
            form.setFieldsValue({
                company: studentInfo.company, 
                company_srl: studentInfo.company_srl, 
                name_kor: studentInfo.name_kor, 
                name_eng: studentInfo.name_eng, 
                department: studentInfo.department, 
                position: studentInfo.position, 
                mem_price: studentInfo.mem_price, 
                phone: makeMaskPhoneNumber(studentInfo.phone), 
                email: studentInfo.email, 
                ebill_yn: studentInfo.ebill_yn,
                ebill_etc: studentInfo.ebill_etc, 
                route: studentInfo.route, 
                memo: studentInfo.memo, 
                memo2: studentInfo.memo2, 
                memo3: studentInfo.memo3,
                duty: studentInfo.duty,
                sex: studentInfo.sex,
                age: studentInfo.age,
                edu_name: studentInfo.edu_name,
                edu_crm_srl: studentInfo.edu_crm_srl,
                edu_position: studentInfo.edu_position,
                edu_email: studentInfo.edu_email,
                edu_phone: makeMaskPhoneNumber(studentInfo.edu_phone),
                edu_phone2: studentInfo.edu_phone2,
                acc_name: studentInfo.acc_name,
                acc_crm_srl: studentInfo.acc_crm_srl,
                acc_phone: makeMaskPhoneNumber(studentInfo.acc_phone),
                acc_email: studentInfo.acc_email,
            });

            form.setFieldValue('mem_price', studentInfo.mem_price);

            setMemPrice(studentInfo.mem_price);
            setSalePrice(studentInfo.sale_price);
            setCompanySrl(studentInfo.company_srl);
            setCompanyName(studentInfo.company_match);
            setOrgCompanyName(studentInfo.company);
            setEduCrmSrl(studentInfo.edu_crm_srl);
            setEduCrmName(studentInfo.edu_name_match);
        }
    }, [studentInfo])

    useEffect(() => {
        form.setFieldsValue({
            mem_price: memPrice, 
        });
    }, [])

    useEffect(() => {
        if (insertSuccess || updateSuccess || restoreSuccess || penaltySuccess) {   
            onClose?.(true);
        }
    }, [insertSuccess, updateSuccess, restoreSuccess, penaltySuccess])

    useEffect(() => {
        if (attendSuccess) {   
            refetch();
        }
    }, [attendSuccess])    
    
    useEffect(() => {
        if (!!howknowList) {
            const options = howknowList?.sort((a, b)=>a.display_sort - b.display_sort).filter((item) => item.status_type === 'AV').map((item) => {return {value: item.value, label: item.value}}) || [];
            setRouteOption(options);
        }
    }, [howknowList]);

    return (
    <ModalWrapper open={isOpen} onCancel={onCloseClick} width={700} title={id===0?'교육생 등록':'교육생 수정'} closable>
        <Space direction='vertical' style={{width:'100%'}}>
            <h4 style={{marginBottom:'0px'}}>{lectureInfo.lecture_title}</h4>
            <label ><CheckOutlined /> 고객사</label>
            <Form
                form={form}
                name="StudentInfo"
                layout="horizontal"  
                labelCol={{ flex: '120px' }}
                onFinish={onSubmit}
                style={{width:'100%'}}
                autoComplete="off"
            >
                {(id===0 || !!companySrl) ? (
                    <Form.Item name="company_srl" label={'고객사(기업명)'} rules={[{ required: true, message: '' }]}>
                        <CompanySelectBox required={true} form={form} company_srl={companySrl} onSelected={(value, option) => {setCompanySrl(Number(value)); setCompanyName(option.label); setCompanyInfo(option)}} />
                        <Form.Item style={{ width:'150px', display: 'inline-block', marginLeft: '10px' }}>
                            <label>{studentInfo?.company}</label>
                        </Form.Item>                        
                    </Form.Item>  
                ): (
                    <Form.Item name="company" label={'고객사명(기업명)'} rules={[{ required: true, message: '' }]}>      
                        <Form.Item name={'company'} style={{ width:'150px', display: 'inline-block', marginRight: '10px' }}>
                            <Input type="text" placeholder='' onChange={(e) => {                        
                                const pattern = /[a-z0-9]|[ \[\]{}()<>?|`~!@#$%^&*-_+=,.;:\"'\\]/g;
                                form.setFieldValue('company', e.target.value.replace(pattern, ''));
                            }}/>                   
                        </Form.Item> 
                        <Button type="primary" onClick={onClickCompanyMatch}>고객사 매칭</Button>
                    </Form.Item>                    
                )}
                <Row>
                    <Col span={12}>
                    <Form.Item label={'신청인원'}>
                        <label>{studentInfo?studentInfo.student_cnt:1}명</label>                  
                    </Form.Item> 
                    </Col> 
                    <Col span={12}> 
                    <Form.Item label={'총교육비 (vat포함)'}>
                        <label>{salePrice.toString().replace(/\B(?=(\d{3})+(?!\d))/g, ",")} ({(salePrice*1.1).toFixed(0).toString().replace(/\B(?=(\d{3})+(?!\d))/g, ",")})</label>                  
                    </Form.Item>   
                    </Col>            
                </Row>
                <Form.Item label={'사업자등록증'}>
                    {(!!studentInfo) && ((!!companyInfo && !!companySrl && companySrl > 0)?
                    (studentInfo.business_file_id)?
                    (companyInfo && studentInfo.business_file_id === companyInfo.business_number_file_id)?
                    ( // 등록된 파일이 이미 회사에 등록된경우
                    <Space>
                        <Button onClick={()=>{onDownload && onDownload(studentInfo.business_file_id, studentInfo.business_file_name)}} shape="round" icon={<DownloadOutlined />} size='small' style={{padding:'0px 5px'}}/>
                        {isFileViewer(studentInfo.business_file_name) && (<Button onClick={()=>{onOpenFileViewer(studentInfo.business_file_id, studentInfo.business_file_name)}} shape="round" icon={<SearchOutlined />} size='small' style={{padding:'0px 5px'}}/>)}                                   
                    </Space>               
                    ):( // 등록된 업체 이지만 기존 등록된 파일과 다를 경우
                    <Space>
                        <Button onClick={()=>{onDownload && onDownload(studentInfo.business_file_id, studentInfo.business_file_name)}} shape="round" icon={<DownloadOutlined />} size='small' style={{padding:'0px 5px'}}/>
                        {isFileViewer(studentInfo.business_file_name) && (<Button onClick={()=>{onOpenFileViewer(studentInfo.business_file_id, studentInfo.business_file_name)}} shape="round" icon={<SearchOutlined />} size='small' style={{padding:'0px 5px'}}/>)}                                   
                        <Button onClick={onCompanyBusinessUpdate}>기존 고객사에 반영</Button>
                    </Space>  
                    ):(!!companyInfo.business_number_file_id)?( // 등록된 업체 이지만 기존 업로드된 사업자 등록증이 없을경우
                    <Space>
                        <Button onClick={()=>{onDownload && onDownload(companyInfo.business_number_file_id, companyInfo.business_number_file_name)}} shape="round" icon={<DownloadOutlined />} size='small' style={{padding:'0px 5px'}}/>
                        {isFileViewer(companyInfo.business_number_file_name) && (<Button onClick={()=>{onOpenFileViewer(companyInfo.business_number_file_id, companyInfo.business_number_file_name)}} shape="round" icon={<SearchOutlined />} size='small' style={{padding:'0px 5px'}}/>)}                                   
                    </Space>               
                    ):(
                    <label>사업자 등록증을 업로드 하지 않았습니다.</label>
                    ):(!!studentInfo.business_file_name)?( // 등록된 업체가 아닐 경우
                    <Space>
                        <Button onClick={()=>{onDownload && onDownload(studentInfo.business_file_id, studentInfo.business_file_name)}} shape="round" icon={<DownloadOutlined />} size='small' style={{padding:'0px 5px'}}/>
                        {isFileViewer(studentInfo.business_file_name) && (<Button onClick={()=>{onOpenFileViewer(studentInfo.business_file_id, studentInfo.business_file_name)}} shape="round" icon={<SearchOutlined />} size='small' style={{padding:'0px 5px'}}/>)}                                                           
                    </Space>               
                    ):(<label>사업자 등록증을 업로드 하지 않았습니다.</label>))}
                    
                </Form.Item> 
            </Form>
            <label ><CheckOutlined /> 교육생</label>
            <Form
                form={form}
                name="StudentInfo"
                layout="horizontal"  
                labelCol={{ flex: '120px' }}
                onFinish={onSubmit}
                style={{width:'100%'}}
                autoComplete="off"
            >
                <Row>
                    <Col span={12}>
                    <Form.Item name={'name_kor'} label={'이름'} rules={[{ required: true, message: '' }]}>
                        <Input type="text" placeholder='' />                 
                    </Form.Item> 
                    </Col> 
                    <Col span={12}> 
                    <Form.Item name={'name_eng'} label={'영문명'}>
                        <Input type="text" placeholder='' />                 
                    </Form.Item>   
                    </Col>            
                </Row>
                <Row>
                    <Col span={12}>
                    <Form.Item name={'department'} label={'부서'} rules={[{ required: true, message: '' }]}>
                        <Input type="text" placeholder='' />                 
                    </Form.Item> 
                    </Col> 
                    <Col span={12}> 
                    <Form.Item name={'position'} label={'직급'} rules={[{ required: true, message: '' }]}>
                        <Input type="text" placeholder='' />                 
                    </Form.Item>   
                    </Col>            
                </Row>
                <Form.Item name={'mem_price'} label={(!!studentInfo && studentInfo.student_type == 1)?'위약금 (vat포함)':'교육비 (vat포함)'} rules={[{ required: true, message: '' }]}>
                    <Form.Item name={'mem_price'} style={{ width:'100px', display: 'inline-block', marginRight: '5px' }} rules={[{ required: true, message: '' }]}>
                    <IMaskInput 
                        min={0} 
                        mask = {Number}
                        thousandsSeparator={','}
                        defaultValue={memPrice}
                        className={'ant-input'} 
                        unmask={'typed'} 
                        onAccept = {((value, mask) => {
                            form.setFieldValue('mem_price', value),
                            setMemPrice(Number(value));
                            if (studentInfo) {
                                setSalePrice(studentInfo.sale_price - studentInfo.mem_price + Number(value)); 
                            } else 
                                setSalePrice(Number(value));
                        })}/>       
                    </Form.Item> 
                    <Form.Item  style={{ display: 'inline-block'}}>
                        <label>({(memPrice*1.1).toFixed(0).toString().replace(/\B(?=(\d{3})+(?!\d))/g, ",")})</label>                
                    </Form.Item>                 
                </Form.Item>
                <Row>
                    <Col span={12}>
                    <Form.Item name={'phone'} label={'핸드폰'} rules={[{ required: true, message: '' }]}>
                        <Input placeholder='핸드폰번호를 입력하세요' onChange={(e) => form.setFieldValue('phone', makeMaskPhoneNumber(e.target.value))} />                 
                    </Form.Item> 
                    </Col> 
                    <Col span={12}> 
                    <Form.Item name={'email'} label={'이메일'} rules={[{ required: true, message: '' }]}>
                        <Input type="text" placeholder='' />                 
                    </Form.Item>   
                    </Col>            
                </Row>
                <Row>
                    <Col span={12}>
                    {!!studentInfo && studentInfo.bill_price > 0 ? (
                        <Form.Item label={'결제방법'}>
                            <label>{studentInfo.bill_type} / {studentInfo.bill_date}</label>
                        </Form.Item>
                    ) : (memPrice == 0) ? (
                        <Form.Item label={'결제방법'}>
                            <label>장학생</label>
                        </Form.Item>                        
                    ) : (
                        <Form.Item name={'ebill_yn'} label={'결제방법'} rules={[{ required: true, message: '' }]}>
                            <Form.Item name={'ebill_yn'} style={{ width:'150px', display: 'inline-block', marginRight: '5px' }}>
                                <Select 
                                    placeholder="결제방법 선택" 
                                    style={{width:"150px"}}
                                    options={[
                                        {value:'C', label: '선납금'},
                                        {value:'Y', label: '세금계산서'},
                                        {value:'N', label: '카드'},
                                        {value:'P', label: '포인트'},
                                        {value:'B', label: '현금영수증'},
                                    ]} />                   
                            </Form.Item> 
                            <Form.Item name={'ebill_etc'} style={{ width:'calc(100% - 150px - 10px)', display: 'inline-block', marginRight: '5px' }}>
                                <Input type="text" placeholder='발행일자' />                 
                            </Form.Item> 
                        </Form.Item>
                    )}

                    </Col>  
                    <Col span={12}> 
                    <Form.Item name={'duty'} label={'직책'}>
                        <Select 
                            placeholder="직책 선택" 
                            options={[
                                {value:'대표', label: '대표'},
                                {value:'임원', label: '임원'},
                                {value:'팀장', label: '팀장'},
                                {value:'팀원', label: '팀원'},
                        ]} />               
                    </Form.Item>   
                    </Col>                                   
                </Row>

                <Row>
                    <Col span={12}>
                    <Form.Item name={'sex'} label={'성별'}>
                        <Select 
                            placeholder="성별 선택" 
                            options={[
                                {value:'남성', label: '남성'},
                                {value:'여성', label: '여성'},
                        ]} />                         
                    </Form.Item> 
                    </Col> 
                    <Col span={12}> 
                    <Form.Item name={'age'} label={'나이'}>
                        <Select 
                        placeholder="나이 선택" 
                        options={[
                            {value:'20대', label: '20대'},
                            {value:'30대', label: '30대'},
                            {value:'40대', label: '40대'},
                            {value:'50대', label: '50대'},
                            {value:'60대 이상', label: '60대 이상'},
                        ]} />  
                    </Form.Item>   
                    </Col>            
                </Row>

                <Form.Item name={'route'} label={'신청경로'}>
                    <Select 
                            placeholder="신청경로 선택" 
                            options={routeOption} />               
                </Form.Item>   
                <Form.Item name='memo' label={'메모'}>
                    <TextArea rows={2} placeholder='메모를 입력하세요'/>   
                </Form.Item>      
                <Form.Item name='memo2' label={'교육이력'}>
                    <TextArea rows={2} placeholder='교육이력을 입력하세요'/>   
                </Form.Item>     
                <Form.Item label={'불참이력'}>
                    <Checkbox defaultChecked={viewAttendList} onChange={(e)=>setViewAttendList(e.target.checked)}>불참이력보기</Checkbox>  
                    {viewAttendList && studentAttendList.map((item)=> 
                        <Row key={item.schedule_srl} style={{marginTop:3}}>
                            <Col span={7}>
                                {item.schedule_time}
                            </Col>
                            <Col span={3} style={{alignItems:'center'}}>
                                {item.lecturer}
                            </Col>                            
                            <Col span={10}>
                                <label>{item.lecture_subject}</label>
                            </Col>                            
                            <Col span={3} style={{width:'fit-content', marginLeft:'auto'}}>
                                <Button 
                                    size='small' 
                                    type="default" 
                                    danger={item.history_id > 0} 
                                    onClick={() => 
                                        studentAttend({
                                            history_id:item.history_id, 
                                            b2c_group_srl: item.b2c_group_srl, 
                                            schedule_srl: item.schedule_srl, 
                                            student_id: item.student_id
                                        })
                                    }
                                >{item.history_id > 0 ? '불참':'참석'}</Button>
                            </Col>                            
                        </Row>
                    )}
                </Form.Item>                                       
            </Form>  
            <Space><label ><CheckOutlined /> 교육담당자</label><Button size='small' onClick={onSameStudent}>교육생과 동일</Button></Space>
            <Form
                form={form}
                name="StudentInfo"
                layout="horizontal"  
                labelCol={{ flex: '120px' }}
                onFinish={onSubmit}
                style={{width:'100%'}}
                autoComplete="off"
            >
                {(id===0 || !!eduCrmSrl) ? (
                <Form.Item name="edu_crm_srl" label={'이름'} rules={[{ required: true, message: '' }]}>
                    <CrmSelectBox 
                        form={form} 
                        company={companySrl} 
                        company_name={companyName} 
                        field_name={'edu_crm_srl'}
                        required={true}
                        addCrm={{
                            id:0,
                            name: form.getFieldValue("edu_name"),
                            phone: form.getFieldValue('edu_phone'),
                            tel: form.getFieldValue('edu_phone2'),                            
                            email: form.getFieldValue('edu_email'),
                            position: form.getFieldValue('edu_position'),
                        }}                        
                        onSelected={(value, option) => {
                            setEduCrmSrl(Number(value)); 
                            setEduCrmName(option.label);
                            if (id===0) {
                                form.setFieldValue("edu_email", option.email);
                                form.setFieldValue("edu_phone", option.phone);
                                form.setFieldValue("edu_phone2", option.tel);
                                form.setFieldValue("edu_position", option.position);                                
                            }
                        }}
                    />   
                    {(!!companySrl) && (
                        <Button 
                            type="primary" 
                            style={{marginLeft:'5px'}}
                            onClick={()=>onClickCrmMatch(
                                eduCrmSrl,
                                form.getFieldValue('edu_name'),
                                form.getFieldValue('edu_phone'),
                                form.getFieldValue('edu_email'),
                                form.getFieldValue('edu_position'),
                                form.getFieldValue('edu_phone2')
                            )}
                        >CRM 매칭</Button>                        
                    )}  
                    <Form.Item name="edu_name" noStyle={true}>    
                        <Input type="text" placeholder='' hidden={true} />
                    </Form.Item>                                                           
                </Form.Item>                     
                ): (
                <Form.Item name="edu_name" label={'이름'} rules={[{ required: true, message: '' }]}>    
                    <Form.Item name={'edu_name'} style={{ width:'150px', display: 'inline-block', marginRight: '10px' }}>
                        <Input type="text" placeholder=''/>                      
                    </Form.Item> 
                    {(!!companySrl) && (
                        <Button 
                            type="primary" 
                            onClick={()=>onClickCrmMatch(
                                eduCrmSrl,
                                form.getFieldValue('edu_name'),
                                form.getFieldValue('edu_phone'),
                                form.getFieldValue('edu_email'),
                                form.getFieldValue('edu_position'),
                                form.getFieldValue('edu_phone2')
                            )}
                        >CRM 매칭</Button>
                    )}
                </Form.Item>                    
                )}
                <Row>
                    <Col span={12}>
                    <Form.Item name="edu_position" label={'직급'}>
                        <Input type="text" placeholder=''/>                 
                    </Form.Item> 
                    </Col> 
                    <Col span={12}> 
                    <Form.Item name="edu_email" label={'이메일'}>
                        <Input type="text" placeholder=''/>                 
                    </Form.Item>   
                    </Col>            
                </Row>
                <Row>
                    <Col span={12}>
                    <Form.Item name="edu_phone" label={'핸드폰'}>
                        <Input placeholder='핸드폰번호를 입력하세요' onChange={(e) => form.setFieldValue('edu_phone', makeMaskPhoneNumber(e.target.value))} />                 
                    </Form.Item> 
                    </Col> 
                    <Col span={12}> 
                    <Form.Item name="edu_phone2" label={'유선전화'}>
                    <Input placeholder='전화번호를 입력하세요' onChange={(e) => form.setFieldValue('edu_phone2', makeMaskPhoneNumber(e.target.value))} />  
                    </Form.Item>   
                    </Col>            
                </Row>
            </Form>
            <Space><label ><CheckOutlined /> 결제담당자</label><Button size='small' onClick={onSameCrm}>교육담당자와 동일</Button></Space>
            <Form
                form={form}
                name="StudentInfo"
                layout="horizontal"  
                labelCol={{ flex: '120px' }}
                onFinish={onSubmit}
                style={{width:'100%'}}
                autoComplete="off"
            >
                <Form.Item name="acc_name" label={'이름'} rules={[{ required: true, message: '' }]}>    
                    <Form.Item name={'acc_name'} style={{ width:'150px', display: 'inline-block', marginRight: '10px' }}>
                        <Input type="text" placeholder=''/>                      
                    </Form.Item> 
                </Form.Item>                    
                <Row>
                    <Col span={12}>
                    <Form.Item name="acc_phone" label={'핸드폰'}>
                        <Input placeholder='핸드폰번호를 입력하세요' onChange={(e) => form.setFieldValue('acc_phone', makeMaskPhoneNumber(e.target.value))} />
                    </Form.Item> 
                    </Col> 
                    <Col span={12}> 
                    <Form.Item name="acc_email" label={'이메일'}>
                        <Input type="text" placeholder=''/>                 
                    </Form.Item>   
                    </Col>            
                </Row>
                <ButtonGroup className={'buttonsWrapper'}>
                    <div>
                        <Button onClick={onCloseClick} style={{marginRight: "5px"}}>닫기</Button>
                        {(!!studentInfo && studentInfo.status_type == 'AV' && studentInfo.student_type == 0) && (
                            <>
                                <Button onClick={()=>onDelete(true)} style={{marginRight: "5px", width:'80px'}}>일정연기</Button>
                                <Button onClick={()=>onDelete(false)} style={{marginRight: "5px", width:'80px'}}>일정취소</Button>
                                <Button onClick={onReinforce} style={{marginRight: "5px", width:'80px'}}>보강</Button>
                            </>
                        )}
                        {(!!studentInfo && studentInfo.status_type == 'AV' && (studentInfo.student_type == 1 || studentInfo.student_type == 2)) && (
                            <Button onClick={()=>onDelete(false)} style={{marginRight: "5px", width:'80px'}}>일정취소</Button>
                        )}                        
                        {(!!studentInfo && studentInfo.status_type != 'AV') && (
                            <>
                                <Popconfirm
                                    title="일정을 복원 하시겠습니까?"
                                    okText="복원"
                                    cancelText="취소"
                                    onConfirm={() => onRestore()}
                                >   
                                    <Button style={{marginRight: "5px", width:'80px'}} >일정복원</Button>
                                </Popconfirm>   
                                <Popconfirm
                                    title="위약금 등록 하시겠습니까?"
                                    okText="등록"
                                    cancelText="취소"
                                    onConfirm={() => onPenalty()}
                                >   
                                    <Button style={{marginRight: "5px", width:'80px'}} >위약금</Button>
                                </Popconfirm>                                                  
                            </>
                        )}                        
                    </div>
                    <div>
                        <Button  htmlType="submit" type="primary">{id===0?'등록':'수정'}</Button>
                    </div>                      
                </ButtonGroup> 
            </Form>
        </Space>        
    </ModalWrapper>  
    )    
};

export default React.memo(StudentEditModal);    